export const COMMON_PAGE_LOADED = 'Common::PageLoaded';
